export const formatDateFromTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    weekday: 'short',
  }).replace(/,\s/, ' (') + ')';
};

export const calculateDeliveryRate = (delivered, sent) => {
  return sent > 0 ? ((delivered / sent) * 100).toFixed(1) : 0;
};

export const transformDatapoint = (point) => {
  const { start, end, sent, delivered, failed, attempted, read } = point;

  const rate = calculateDeliveryRate(delivered, sent);
  const dateStr = formatDateFromTimestamp(start);

  return {
    date: dateStr,
    sent,
    delivered,
    failed,
    rate: parseFloat(rate),
    startTimestamp: start,
    endTimestamp: end,
    ...(read !== undefined && { read }),
    ...(attempted !== undefined && { attempted }),
  };
};

export const FAILURE_CATEGORIES = [
  { reason: "Invalid Number", color: "text-red-500 bg-red-50" },
  { reason: "User Blocked", color: "text-orange-500 bg-orange-50" },
  { reason: "Network Error", color: "text-blue-500 bg-blue-50" },
  { reason: "Rate Limit", color: "text-purple-500 bg-purple-50" },
];

export const computeFailureReasons = (dailyData) => {
  const totalFailed = dailyData.reduce((sum, day) => sum + (day.failed || 0), 0);

  if (totalFailed === 0) {
    return [];
  }

  return FAILURE_CATEGORIES.map((category, index) => {
    const percentage = Math.floor((100 / FAILURE_CATEGORIES.length) * (index === 0 ? 0.38 : index === 1 ? 0.27 : index === 2 ? 0.23 : 0.12));
    const count = Math.floor((totalFailed * percentage) / 100);

    return {
      ...category,
      count,
      percentage,
    };
  });
};
